import { render, staticRenderFns } from "./OverlayModal.vue?vue&type=template&id=6ff412a0&scoped=true&"
import script from "./OverlayModal.vue?vue&type=script&lang=js&"
export * from "./OverlayModal.vue?vue&type=script&lang=js&"
import style0 from "./OverlayModal.vue?vue&type=style&index=0&id=6ff412a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff412a0",
  null
  
)

export default component.exports